class JwtService extends BaseService
	@register()

	parse: (jwtToken) ->
		jwtData = jwtToken.split('.')

		if jwtData.length != 3
			throw Error('Invalid JWT token provided')

		return JSON.parse(atob(jwtData[1]))
